import {utilHelper} from "../../_helpers";

const relativeUrl = 'api/xailingRoutProduct'

export const xailingRoutProductService = {
    listChilds,
    addChild,
    removeChild
};

function listChilds(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/listChilds`, 'POST', { data, showAlert: false });
}

function addChild(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/add`, 'POST', { data });
}

function removeChild(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/remove`, 'POST', { data });
}